import { ChecklistTemplateRepository } from "../../repositories/ChecklistTemplateRepository";
import {
  ChecklistTemplateEntity,
  ChecklistTemplateItemEntity,
} from "../../entities/ChecklistTemplateEntity";

/**
 * Update Template Use Case
 * Updates the active month-end checklist template
 */
export class UpdateTemplateUseCase {
  constructor(private repository: ChecklistTemplateRepository) {}

  async execute(
    templateId: number,
    data: Partial<ChecklistTemplateEntity> & {
      items?: ChecklistTemplateItemEntity[];
    }
  ): Promise<ChecklistTemplateEntity> {
    return await this.repository.updateTemplate(templateId, data);
  }
}
